import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom"; // if using react-router
import { getPageDetailBySlug } from "../../features/user/userSlice";
import DynamicPage from "./DynamicPage";
import { CircularProgress, Box, Typography } from "@mui/material";

const DynamicPageWrapper = () => {
  const { slug } = useParams(); // e.g. /pages/how-it-works-overview
  const dispatch = useDispatch();

  // console.log('Slug in Details page:',slug)

  const { pageDetail, blogLoading, blogError } = useSelector(
    (state) => state.user // adjust if slice is named differently
  );

  // console.log('Details page:',pageDetail)

  useEffect(() => {
    if (slug) {
      dispatch(getPageDetailBySlug(slug));
    }
  }, [slug, dispatch]);

  if (blogLoading) {
    return (
      <Box
        sx={{
          minHeight: "50vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (blogError) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <Typography color="error">Failed to load page: {blogError}</Typography>
      </Box>
    );
  }

  if (!pageDetail) {
    return null; // nothing yet
  }

  return <DynamicPage pageData={pageDetail} />;
};

export default DynamicPageWrapper;
